import React, { FC, useEffect, useRef } from 'react'

type EditableInlineTextProps = {
    value: string
    editing: boolean
    className?: string
    style?: React.CSSProperties
    onCommit: (text: string) => void
    onCancel: () => void
}

export const EditableInlineText: FC<EditableInlineTextProps> = ({
    value,
    editing,
    className,
    style,
    onCommit,
    onCancel,
}) => {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!editing || !ref.current) {
            return
        }

        ref.current.focus()
        const range = document.createRange()
        range.selectNodeContents(ref.current)
        range.collapse(false)
        const selection = window.getSelection()
        selection?.removeAllRanges()
        selection?.addRange(range)
    }, [editing])

    return (
        <div
            ref={ref}
            className={className}
            style={style}
            contentEditable={editing}
            suppressContentEditableWarning
            onMouseDown={(event) => {
                if (editing) {
                    event.stopPropagation()
                }
            }}
            onDoubleClick={(event) => {
                if (editing) {
                    event.stopPropagation()
                }
            }}
            onBlur={(event) => {
                if (editing) {
                    onCommit(event.currentTarget.innerText)
                }
            }}
            onKeyDown={(event) => {
                if (!editing) {
                    return
                }

                event.stopPropagation()

                if (event.key === 'Escape') {
                    event.preventDefault()
                    onCancel()
                    return
                }

                if (event.key === 'Enter' && !event.shiftKey) {
                    event.preventDefault()
                    onCommit(event.currentTarget.innerText)
                }
            }}
        >
            {value}
        </div>
    )
}
